/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AssignEditorialReviewerToActivity$Params {
  activityId: number;
  culture: string;
  reviewerId?: number;
}

export function assignEditorialReviewerToActivity(http: HttpClient, rootUrl: string, params: AssignEditorialReviewerToActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, assignEditorialReviewerToActivity.PATH, 'put');
  if (params) {
    rb.path('activityId', params.activityId, {});
    rb.query('culture', params.culture, {});
    rb.query('reviewerId', params.reviewerId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

assignEditorialReviewerToActivity.PATH = '/api/editorial/activities/{activityId}/assign-reviewer';
